module.exports = __webpack_public_path__ + "media/images/menu/ursa_major-723c76d5ca1c2e8120cae7641593a35c.jpg";